import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Message } from 'semantic-ui-react'

export default function Messages({ formState }) {
  let { messages = List() } = formState
  return messages
    .map((message, key) => {
      let type = 'error'
      let content = ''

      if (typeof message === 'string') {
        content = message
      } else if (Map.isMap(message)) {
        type = message.get('type', 'error')
        content = message.get('message', '')
      }

      let messageProps = {
        key,
        content,
      }

      if (type === 'error') messageProps.error = true

      if (type === 'warning') messageProps.warning = true

      if (type === 'success') messageProps.success = true

      return <Message {...messageProps} />
    })
    .toArray()
}
